import React from 'react';

const SvgSave = (props) => (
  <svg width={'100%'} viewBox="0 0 32 32" {...props}>
    <path
      d="M24 11L14 21l-5-5"
      stroke="#f7f9f9"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
      fill="none"
    />
    <path fill="none" d="M0 0h32v32H0z" />
  </svg>
);

export default SvgSave;
